import jwtDecode from 'jwt-decode'
import Cookies from 'universal-cookie'
import { CognitoUser, CognitoUserAttribute, CognitoUserPool } from 'amazon-cognito-identity-js'
import { CognitoAuth } from 'amazon-cognito-auth-js'

const AmazonCognitoIdentity = require('amazon-cognito-identity-js')

import settings from 'settings'

export const verifyEmail = payload => new Promise((resolve, reject) => {
  const poolData = {
    UserPoolId: settings.cognito.authData.UserPoolId,
    ClientId: settings.cognito.authData.ClientId,
  }

  const userPool = new CognitoUserPool(poolData)
  const userData = {
    Username: payload.username,
    Pool: userPool,
  }
  const cognitoUser = new CognitoUser(userData)
  cognitoUser.confirmRegistration(payload.verificationCode, true, (err, result) => {
    if (err) {
      return reject(err)
    }

    return resolve(result)
  })
})

export const getConfirmedStatus = payload => new Promise((resolve, reject) => {
  const poolData = {
    UserPoolId: settings.cognito.authData.UserPoolId,
    ClientId: settings.cognito.authData.ClientId,
  }
  const userPool = new CognitoUserPool(poolData)
  const userData = {
    Username: payload.email,
    Password: '******************',
  }
  const userPoolData = {
    Username: payload.email,
    Pool: userPool,
  }

  const authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(userData)
  const cognitoUser = new CognitoUser(userPoolData)

  cognitoUser.authenticateUser(authenticationDetails, {
    onSuccess(result) {
      resolve(result)
    },
    onFailure(err) {
      const confirmed = err.code !== 'UserNotConfirmedException'
      reject(new Error(confirmed ? 'CONFIRMED' : 'NOT_CONFIRMED'))
    },
  })
})

export const resendVerificationCode = payload => new Promise((resolve, reject) => {
  const poolData = {
    UserPoolId: settings.cognito.authData.UserPoolId,
    ClientId: settings.cognito.authData.ClientId,
  }
  const userPool = new CognitoUserPool(poolData)
  const userData = {
    Username: payload.username,
    Pool: userPool,
  }
  const cognitoUser = new CognitoUser(userData)
  cognitoUser.resendConfirmationCode((err, result) => {
    if (err) {
      reject(err)
    }
    resolve(result)
  })
})

export const resetPassword = payload => new Promise((resolve, reject) => {
  const poolData = {
    UserPoolId: settings.cognito.authData.UserPoolId,
    ClientId: settings.cognito.authData.ClientId,
  }
  const userPool = new CognitoUserPool(poolData)
  const userData = {
    Username: payload.username,
    Pool: userPool,
  }
  const cognitoUser = new CognitoUser(userData)
  cognitoUser.confirmPassword(payload.verificationCode, payload.password, {
    onSuccess: (result) => {
      resolve(result)
    },
    onFailure: (err) => {
      reject(err)
    },
  })
})

export const sendForgotPasswordEmail = payload => new Promise((resolve, reject) => {
  const poolData = {
    UserPoolId: settings.cognito.authData.UserPoolId,
    ClientId: settings.cognito.authData.ClientId,
  }
  const userPool = new CognitoUserPool(poolData)
  const userData = {
    Username: decodeURIComponent(payload.email),
    Pool: userPool,
  }
  const cognitoUser = new CognitoUser(userData)
  cognitoUser.forgotPassword({
    onSuccess: (result) => {
      resolve(result)
    },
    onFailure: (err) => {
      reject(err)
    },
  })
})

export const registerUser = payload => new Promise((resolve, reject) => {
  const poolData = {
    UserPoolId: settings.cognito.authData.UserPoolId,
    ClientId: settings.cognito.authData.ClientId,
  }
  const userPool = new CognitoUserPool(poolData)
  const attributeList = []
  const dataEmail = {
    Name: 'email',
    Value: payload.email,
  }
  const attributeEmail = new CognitoUserAttribute(dataEmail)

  attributeList.push(attributeEmail)

  userPool.signUp(payload.email, payload.password, attributeList, null, (err, result) => {
    if (err) {
      return reject(err)
    }

    return resolve(result.user)
  })
})
export const loginUser = payload => new Promise((resolve, reject) => {
  const poolData = {
    UserPoolId: settings.cognito.authData.UserPoolId,
    ClientId: settings.cognito.authData.ClientId,
  }
  const userPool = new CognitoUserPool(poolData)
  const userData = {
    Username: payload.email,
    Password: payload.password,
  }
  const userPoolData = {
    Username: payload.email,
    Pool: userPool,
  }
  const authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(userData)
  const cognitoUser = new CognitoUser(userPoolData)

  cognitoUser.authenticateUser(authenticationDetails, {
    onSuccess(result) {
      resolve(result)
    },
    onFailure(err) {
      reject(err)
    },
  })
})

export const getUser = () =>
  new Promise((resolve, reject) => {
    const clientId = localStorage.getItem('hackedu.cognito.clientId')
    let poolData = null
    if (clientId === '1p6bb22tops0hjelbk500j5son') {
      poolData = {
        UserPoolId: settings.cognito.authDataHackEDU.UserPoolId,
        ClientId: settings.cognito.authDataHackEDU.ClientId,
      }
    } else if (clientId === '46m8aq1d3s534d9vuqv8hks801') {
      poolData = {
        UserPoolId: settings.cognito.authDataAllegiant.UserPoolId,
        ClientId: settings.cognito.authDataAllegiant.ClientId,
      }
    } else {
      poolData = {
        UserPoolId: settings.cognito.authData.UserPoolId,
        ClientId: settings.cognito.authData.ClientId,
      }
    }
    const userPool = new CognitoUserPool(poolData)
    const user = userPool.getCurrentUser()

    if (user != null) {
      user.getSession((err) => {
        if (err) {
          console.error('Error with user.getSession(): ', err)
          return reject(err)
        }
        return resolve(user)
      })
    } else {
      return reject(new Error('user is null'))
    }
  })

export const getUsernameFromJWT = (jwt) => {
  const decoded = jwtDecode(jwt)
  if (decoded['cognito:username'] !== undefined) {
    return decoded['cognito:username']
  }
  return decoded.username
}

export const getEmailFromJWT = (jwt) => {
  const claims = jwtDecode(jwt)

  if ('email' in claims) {
    return claims.email
  } else if ('cognito:username' in claims && claims['cognito:username'].includes('@') &&
    claims['cognito:username'].includes('.')) {
    const username = claims['cognito:username']

    const i = username.indexOf('_')
    const emailParts = [username.slice(0, i), username.slice(i + 1)]

    if (emailParts.length > 1) {
      return emailParts[1]
    }
    return emailParts[0]
  }

  return null
}

export const logout = () => {
  const clientId = localStorage.getItem('hackedu.cognito.clientId')
  let poolData = null
  if (clientId === '1p6bb22tops0hjelbk500j5son') {
    poolData = {
      UserPoolId: settings.cognito.authDataHackEDU.UserPoolId,
      ClientId: settings.cognito.authDataHackEDU.ClientId,
    }
  } else if (clientId === '46m8aq1d3s534d9vuqv8hks801') {
    poolData = {
      UserPoolId: settings.cognito.authDataAllegiant.UserPoolId,
      ClientId: settings.cognito.authDataAllegiant.ClientId,
    }
  } else {
    poolData = {
      UserPoolId: settings.cognito.authData.UserPoolId,
      ClientId: settings.cognito.authData.ClientId,
    }
  }
  const userPool = new CognitoUserPool(poolData)
  const cognitoUser = userPool.getCurrentUser()

  if (cognitoUser !== null) {
    cognitoUser.signOut()
  }

  let authData = null
  if (clientId === '1p6bb22tops0hjelbk500j5son') {
    authData = settings.cognito.authDataHackEDU
  } else if (clientId === '46m8aq1d3s534d9vuqv8hks801') {
    authData = settings.cognito.authDataAllegiant
  } else {
    authData = settings.cognito.authData
  }
  const auth = new CognitoAuth(authData)
  auth.signOut()
  const pathname = localStorage.getItem('hackedu.redirect.login.pathname')
  const search = localStorage.getItem('hackedu.redirect.login.search')
  if (pathname) {
    let url = pathname
    if (search) {
      url = pathname + search
    }
    localStorage.removeItem('hackedu.redirect.login.pathname')
    localStorage.removeItem('hackedu.redirect.login.search')
    window.location.assign(url)
  } else {
    window.location.assign(`${settings.urls.www}`)
  }
}

export const getAnonymousId = () => {
  const cookies = new Cookies()
  const uuidv4 = () => ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16))

  if (cookies.get('ajs_anonymous_id') !== undefined) {
    return cookies.get('ajs_anonymous_id')
  } else if (cookies.get('hackedu_anonymous_id') !== undefined) {
    return cookies.get('hackedu_anonymous_id')
  }
  const uuid = uuidv4()
  cookies.set('hackedu_anonymous_id', uuid, { path: '/' })
  return uuid
}
